import { RouteInterface } from '@interface/route/route.interface';

export const initialRouteState: RouteInterface = {
  name: '',
  path: '',
};
